module.exports = __webpack_public_path__ + "static/PatKT-01-ae25dca97b05a12c11d57d43fe4797e5.jpg";